// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageHeaderSkeleton-moduleEmailProfileMessageHeaderSkeleton__aKXLI EmailProfileMessageHeader-moduleEmailProfileMessageHeader__ZnKGK";
var _2 = "EmailProfileMessageHeaderSkeleton-moduleaction__otOxU";
var _3 = "EmailProfileMessageHeaderSkeleton-moduleactions__KLfkH";
var _4 = "EmailProfileMessageHeaderSkeleton-moduleactionsContainer__eij8f";
var _5 = "EmailProfileMessageHeaderSkeleton-moduleavatar__j5PRZ";
var _6 = "EmailProfileMessageHeaderSkeleton-moduledate__Qcc5N";
var _7 = "EmailProfileMessageHeaderSkeleton-moduleheader___ipwV";
var _8 = "EmailProfileMessageHeaderSkeleton-moduleinfo__bijVb";
var _9 = "EmailProfileMessageHeaderSkeleton-modulename__pa5hw";
var _a = "EmailProfileMessageHeaderSkeleton-moduleto__x7IVT";
export { _1 as "EmailProfileMessageHeaderSkeleton", _2 as "action", _3 as "actions", _4 as "actionsContainer", _5 as "avatar", _6 as "date", _7 as "header", _8 as "info", _9 as "name", _a as "to" }
